window.addEventListener('DOMContentLoaded', () => {
  let header = document.getElementById('shopify-section-header');

  if (header) {
    stickyHeader(header);
  }

  function stickyHeader(header) {
    let lastPosition = window.scrollY;
    document.addEventListener('scroll', event => {
      if (lastPosition > window.scrollY) {
        header.classList.add('sticky-header');
      } else {
        header.classList.remove('sticky-header');
      }

      lastPosition = window.scrollY;
    });
  }

  (function handleFirstLevelSubmnenus() {
    document.querySelectorAll('.mobile-menu-level-1-open').forEach(opener => {
      const details = opener.closest('details');
      const mainList = details.closest('.mobilemenu__link-list');

      if (details && mainList) {
        opener.addEventListener('click', () => {
          mainList.scrollTo({
            top: 0,
            behavior: 'instant'
          });
          mainList.classList.toggle('no-overflow', !details.open);
        });
      }
    });
    document.querySelectorAll('.mobile-menu-level-1-close').forEach(closer => {
      const opener = closer.closest('details').querySelector('summary');

      if (opener) {
        closer.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();
          opener.click();
        });
      }
    });
  })();
});
